import React, { useEffect } from "react";
import "./orderTable.css";
import styled from "@emotion/styled";
import { useState } from "react";

export const TableContainer = styled("div")(
  {
    background: "#ffffff",
    border: "1px solid #e7e5ff",
    borderTopLeftRadius: "15px",
    borderTopRightRadius: "15px",
    maxWidth: "45rem",
    height: "25rem",
    overflowY: "auto",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

export const TableFooter = styled("div")(
  {
    background: "#2AD3E7",
    border: "1px solid #e7e5ff",
    borderBottomLeftRadius: " 15px",
    borderBottomRightRadius: "15px",
    maxWidth: "45rem",
    height: "3rem",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

const CustomerOrdersTable = ({ maxWidth = "60rem", orderList }) => {
  const [total, setTotal] = useState(0);
  useEffect(() => {
    let total = 0;
    orderList?.forEach((ex) => {
      total += parseInt(ex.total);
    });
    setTotal(total);
  }, [orderList]);

  return (
    <div className="">
      <TableContainer maxWidth={maxWidth}>
        <table className="main-table text-nowrap overflow-scroll">
          <tr className="table-rows">
            <th className="table-heads" width={"5%"}>
              Product ID
            </th>
            <th className="table-heads" width={"10%"}>
              Product Name
            </th>
            <th className="table-heads" width={"10%"}>
              Division
            </th>
            <th className="table-heads" width={"5%"}>
              Qty
            </th>

            <th className="table-heads" width={"8%"}>
              Price
            </th>
          </tr>
          {orderList?.map((ele, index) =>
            ele?.orderProducts?.map((ex, idx) => {
              // console.log(ele.total);
              return (
                <tr className="table-rows1" index={idx}>
                  <td className="table-each-row-data">
                    {ex?.product?.product_id}
                  </td>
                  <td className="table-each-row-data">
                    {ex?.product?.product_name}
                  </td>
                  <td className="table-each-row-data">
                    {ex?.vendorDivision?.name}
                  </td>
                  <td className="table-each-row-data">
                    {ex?.offer_type == "quantity" &&
                      `${ex?.quantity} + ${ex?.offer_qty}`}
                    {ex?.offer_type !== "quantity" && `${ex?.quantity}`}
                  </td>
                  <td className="table-each-row-data">₹ {ele?.total}</td>
                </tr>
              );
            })
          )}
        </table>
      </TableContainer>
      <TableFooter
        className="d-flex justify-content-between align-items-center px-4 table-footer"
        maxWidth={maxWidth}
      >
        <div>
          <label className="text-white ">Total</label>
        </div>
        <div>
          <label className="text-white fw_600 mx-5">₹ {total}</label>
        </div>
      </TableFooter>
    </div>
  );
};

export default CustomerOrdersTable;
